/**
 * 终端的显示标签 —— **不是数据,是文案**,所以不该住在 `mocks/` 里。
 *
 * 2026-07-28: 这四张表原来定义在 `mocks/fleet.ts`, 于是【已经接了真数据的页面】
 * (设备、总览、网络)也得从 mocks 里 import 才能拿到中文名。
 * 后果不是坏渲染, 是【判据失效】: `grep -rl "mocks/" src/` 这条最直接的
 * "谁还在用假数据" 的普查, 会把一批真页面算进去 —— 分母一脏, 就没人能一眼说清
 * 还剩几页是假的。判据量不准, 比没有判据更糟。
 *
 * 规矩: `mocks/` 里只放【假的数据】。文案、图标、枚举映射放这里。
 */

/** kind → 中文名。'other' 必须在: 注册表里 kind 映射不到的设备会落到这一类。 */
export const typeLabels: Record<string, string> = {
  dog: '机器狗',
  glasses: 'AI眼镜',
  phone: '手机',
  drone: '无人机',
  vehicle: '无人车',
  other: '其他',
};

export const typeIcons: Record<string, string> = {
  dog: 'ri-android-line',
  glasses: 'ri-glasses-line',
  phone: 'ri-smartphone-line',
  drone: 'ri-flight-takeoff-line',
  vehicle: 'ri-car-line',
  other: 'ri-question-line',
};

export const capabilityLabels: Record<string, string> = {
  full: '全通',
  desynced: '失协同',
  offline_auto: '离线自治',
  minimal: '最小',
};

export const capabilityDescriptions: Record<string, string> = {
  full: '全部功能可用',
  desynced: '能力没降，但暂时不能与队伍协作',
  offline_auto: '只能做简单的事',
  minimal: '仅保证不丢数据',
};
